import DxmlRun from "../DxmlRun"
import DxmlInputField from "../DxmlInputField"
import DxmlHyperlink from "../DxmlHyperlink"
import DxmlAutoDate from "../DxmlAutoDate"
import * as Constants from "../../../../../utils/constants"
import { useEditorFile } from "../../../../../hooks/useEditorFile";

export default function DxmlParagraph({ editorParagraph, firstParagraphInList = false }) {
    const hasOneInputFieldInParagraph = editorParagraph.Items && editorParagraph.Items.length === 1 && editorParagraph.Items[0].Type === Constants.editorType.inputField ? true : false;

    if (firstParagraphInList) {
        if (editorParagraph.Items.length === 0) {
            return (
                <br style={editorParagraph.ReactCssStyle} />
            )
        } else {
            return (
                <>
                    {
                        editorParagraph.Items.map((editorBaseModel) => (
                            SubComponent(editorBaseModel, hasOneInputFieldInParagraph)
                        ))
                    }
                </>
            )
        }
    }

    if (!firstParagraphInList && editorParagraph.Items.length === 0) {
        return (
            <p style={editorParagraph.ReactCssStyle}>
                <br />
            </p>
        )
    }

    return (
        <p style={editorParagraph.ReactCssStyle}>
            {editorParagraph.Items.map((editorBaseModel) => (
                SubComponent(editorBaseModel, hasOneInputFieldInParagraph)
            ))}
        </p>
    )
}

function SubComponent(editorBaseModel, hasOneInputFieldInParagraph) {
    const { getKeyById } = useEditorFile();

    if (editorBaseModel.Type === Constants.editorType.run) {
        return <DxmlRun key={getKeyById(editorBaseModel)} editorRun={editorBaseModel}></DxmlRun>
    } else if (editorBaseModel.Type === Constants.editorType.inputField) {
        return <DxmlInputField key={getKeyById(editorBaseModel)} editorInputField={editorBaseModel} hasOneInputFieldInParagraph={hasOneInputFieldInParagraph}></DxmlInputField>
    } else if (editorBaseModel.Type === Constants.editorType.hyperLink) {
        return <DxmlHyperlink key={getKeyById(editorBaseModel)} editorHyperlink={editorBaseModel}></DxmlHyperlink>
    } else if (editorBaseModel.Type === Constants.editorType.autoDate) {
        return <DxmlAutoDate key={getKeyById(editorBaseModel)} editorAutoDate={editorBaseModel}></DxmlAutoDate>
    } else {
        return <></>
    }
}